import { createSlice } from "@reduxjs/toolkit";

import { getPlans } from "../api";
import {
  createAsyncActionsHandler,
  createAsyncActionsMatcher,
} from "./handleAsyncAction";

const asyncThunks = [{ source: getPlans }];

const subscriptionPlansSlice = createSlice({
  name: "subscriptionPlans",
  initialState: {
    data: null,
    status: null,
    error: null,
  },
  reducers: {
    resetConfigState: (state) => {
      state.data = null;
      state.status = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      createAsyncActionsMatcher(asyncThunks),
      createAsyncActionsHandler(asyncThunks)
    );
  },
});

export const { resetConfigState } = subscriptionPlansSlice.actions;
export default subscriptionPlansSlice.reducer;
